<script lang="ts">
  import { Title, List, Spinner } from '$shared/components';

  interface Props {
    title?: string;
    loading?: boolean;
    list?: IDataList;
    onevent?: (payload: any) => void;
  }

  let { title = '', loading = false, list = {}, onevent }: Props = $props();
</script>

<div class="npdb-section">
  {#if title}
    <div class="title">
      <Title type="h3">{title}</Title>
      {#if loading}
        <div class="icon">
          <Spinner />
        </div>
      {/if}
    </div>
  {/if}
  <div class="list">
    <List {list} {onevent} />
  </div>
</div>

<style>
  .npdb-section {
    margin-bottom: 48px;
  }
  .npdb-section .title {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
  }
  .npdb-section .title .icon {
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
</style>
